import React from 'react';
import { GridGroupByProps } from '../../../../../components/shared/grid/types';
import { CostReportItem } from '../../../../../features/cost-report/types';
import CostReportGroupRow from '../../cost-report-group-row';

interface CreateGroupByParams {
    onAddNewCostClick: (cost: CostReportItem) => void;
    canManageCost: (cost: CostReportItem) => boolean;
    amountColumnWidth?: number;
    groupField?: string;
}

export const createGroupBy = ({
    onAddNewCostClick,
    canManageCost,
    amountColumnWidth,
    groupField = 'employeeId',
}: CreateGroupByParams): GridGroupByProps => ({
    rowGroupingModel: [groupField],
    groupByRenderer: (groupField, groupFieldValue, value, intl) => {
        const items = value as CostReportItem[];
        const employeeName = items[0]?.employeeName ?? groupFieldValue;
        return (
            <CostReportGroupRow
                employeeName={employeeName}
                totalAmount={items.reduce((sum, a) => sum + a.amount, 0)}
                intl={intl}
                amountColumnWidth={amountColumnWidth}
                onAddNewCostClick={canManageCost(items[0]) ? () => onAddNewCostClick({ ...items[0] }) : undefined}
            />
        );
    },
    isGroupHasValues: (values) => values.find((x) => x.id !== -1) !== undefined,
});
